export default class formConfig {
  // 企业登记信息-详情
  static configList() {
    return [
      {
        title: "标段详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "标段号：",
            value: "section",
            type: "slot",
            slotName: "section",
            rule: {
              type: "number",
              required: true,
              message: "请填写正确的数字！",
              trigger: "blur"
            },
          },
          {
            label: "标段描述：",
            value: "description",
            type: "input",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "标段（包）招标次数：",
            value: "bidSectionNum",
            type: "slot",
            slotName: "bidSectionNum",
            rule: {
              type: "number",
              required: true,
              message: "请填写正确的数字！",
              trigger: "blur"
            },
          },
          {
            label: "标段合同估算价（万元）：",
            value: "contractReckonPrice",
            type: "input",
            tip: "请输入“标段合同估算价”（估算价须高于0元）！",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          // {
          //   label: "标段合同估算价币种：",
          //   value: "currencyCode",
          //   type: "select",
          //   required: true,
          //   rule: {
          //     required: true,
          //     message: "该输入项不能为空",
          //     trigger: "change"
          //   },
          //   queryParams: {
          //     url: "/dataDictionaryEntries/BasicDataCombobox",
          //     zdid: "201507061217010003"
          //   },
          // },
          // {
          //   label: "标段合同估算价单位：",
          //   value: "priceUnit",
          //   type: "select",
          //   clearable: true,
          //   optionData: [
          //     { name: "元", value: "1" },
          //     { name: "万元", value: "2" },
          //   ],
          //   rule: {
          //     required: true,
          //     message: "该输入项不能为空",
          //     trigger: "change"
          //   },
          // },
          {
            label: "标段（包）分类：",
            value: "tenderProjectClassifyCodeSelect",
            slotName: "tenderProjectClassifyCode",
            type: "slot",
            tip: "请选择最小分类，最多只能选择3个。",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: ["blur","change"]
            },
          },
          {
            label: "投标有效期（日历天）：",
            value: "tenderValidityDay",
            type: "number",
            maxlength: 10,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "是否远程评标标段：",
            value: "isRemoteEvaluating",
            type: "select",
            clearable: true,
            disabled: true,
            optionData: [
              { name: "否", value: "0" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "不远程评标原因：",
            value: "noRemoteReason",
            disabled: true,
            type: "input",
            width: "100%",
            tip: "“省、武汉市、武汉市远城区交易（采购）中心使用省综合评标（评审）专家库武汉区域库，专家资源比较充足，原则上不作为主场开展政府投资项目省内远程异地评标”。",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "是否十大工程项目：",
            value: "isSdgc",
            type: "select",
            clearable: true,
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "是否政府投资项目：",
            value: "isGovernmentInvestment",
            type: "select",
            clearable: true,
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "是否使用财政性资金：",
            value: "isFinancialCapital",
            type: "select",
            clearable: true,
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "标段（包）所在行政区域：",
            value: "sectionAreaCode",
            type: "select",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "202109241434440618"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "交易发生行政区域：",
            value: "dealAreaCode",
            type: "select",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "202109241434440618"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "采购计划备案号：",
            value: "cgjhbaCode",
            slotName: "cgjhbaCode",
            type: "slot",
            width: "50%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "",
            type: "slot",
            class: "formList",
            width: "100%;",
            slotName: "listPrjDetail",
            value: "listPrjDetail",
          },
        ]
      },
    ];
  }
}
